import { authorize, putRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function updateGroupAPI(id, group) {
  const url = `${AWS_API_URL}/2n/groups/${id}`;
  return putRequest(url, { data: group }, await authorize());
}

